import type { PropsWithChildren } from 'react';
import { GovIcon } from '@gov-design-system-ce/react';
import type { AisItem } from '@gov-nx/module/page';
import { useKdeOMneStatVedeUdajeContext } from '@gov-nx/module/page';

type AgendaItemProps = PropsWithChildren<{
	ais?: AisItem;
}>;

export const AgendaItem = ({ ais, children }: AgendaItemProps) => {
	const { toggleAis, expandedAis } = useKdeOMneStatVedeUdajeContext();

	const className =
		'anim-bg-hover w-full p-(--spacing-s-nudge) flex justify-between items-center gap-(--spacing-s) cursor-pointer';

	const content = (
		<>
			<span className="text-body-s text-(--text-primary-color) text-left">
				{children}
			</span>
			{!!ais?.nazevAis &&
				(expandedAis === ais?.kodAis ? (
					<GovIcon
						name="chevron-up"
						className="grow-0 shrink-0 w-4 h-4 text-(--text-primary-color)"
					/>
				) : (
					<GovIcon
						name="chevron-down"
						className="grow-0 shrink-0 w-4 h-4 text-(--text-primary-color)"
					/>
				))}
		</>
	);

	if (!ais?.nazevAis) {
		return null;
	}

	return (
		<button
			className={className}
			type="button"
			onClick={() => toggleAis(ais.kodAis)}>
			{content}
		</button>
	);
};
